import { useTranslation } from "react-i18next";
import { ImageIcon, Loader2 } from "@digital-twins/design-system/icons";
import { usePrivateMedia } from "@/hooks/usePrivateMedia";
import { cn } from "@/lib/utils";
import type { PrivateImageProps } from "@/types/creative-library";
import { useDarkImageTile, withDarkTile } from "./imageTone";
export function PrivateImage({
  source,
  alt,
  className,
  testId,
}: PrivateImageProps) {
  const { t } = useTranslation("app");
  const { src, error } = usePrivateMedia(source);
  const { hasDarkTile, onLoad } = useDarkImageTile(src);
  return src ? (
    <img
      src={src}
      alt={alt}
      className={hasDarkTile ? withDarkTile(className) : className}
      data-testid={testId}
      onLoad={onLoad}
    />
  ) : (
    <div
      className={cn(
        "flex items-center justify-center bg-background text-muted-foreground",
        className,
      )}
      data-testid={testId}
    >
      {source && !error ? (
        <Loader2
          className="h-5 w-5 animate-spin"
          aria-label={t("creativeLibrary.loading")}
        />
      ) : (
        <ImageIcon
          className="h-6 w-6"
          aria-label={error ? t("creativeLibrary.imageUnavailable") : alt}
        />
      )}
    </div>
  );
}
